import { eventsEpics } from '../modules/events/store/events.epics'

export const appEpics = [...eventsEpics]
